import { getGroupsList } from '@/infrastructure/sdk';
import { store, setSyncProgress } from '@/app/store';
import { createLogger, yieldToMain } from '@/infrastructure/sync/utils';

const { log, logTime, flushLogs } = createLogger('GroupSync');

// ============================================================================
// MODULE: GroupSync
// ============================================================================

const GroupSync = {
   /**
    * Fetch group list from the SDK/API.
    */
   async fetchFromAPI() {
      try {
         const response = await getGroupsList();
         await yieldToMain();
         return Array.isArray(response) ? response : response?.data || [];
      } catch (err) {
         log('fetchFromAPI', `Error: ${err.message}`);
         return [];
      }
   },
};

/**
 * Synchronizes groups (Redux-only, no IDB).
 *
 * @param {Object} options
 * @param {number[]} options.progressRange  [startProgress, endProgress]
 * @returns {Promise<{ groups: Object[] }>}
 */
export const syncGroups = async (options = {}) => {
   const { progressRange = [3, 10], config = {} } = options;
   const { preFetch } = config;
   const [, endProgress] = progressRange;

   log('Sync', 'Starting synchronization');
   const startTime = performance.now();

   try {
      const apiGroups = await GroupSync.fetchFromAPI();
      if (preFetch) store.dispatch(setSyncProgress(endProgress));
      logTime('Summary', 'Sync completed', startTime);
      return { groups: apiGroups };
   } catch (error) {
      log('Error', `Process failed: ${error.message}`);
      if (preFetch) store.dispatch(setSyncProgress(endProgress));
      return { groups: [] };
   } finally {
      const duration = ((performance.now() - startTime) / 1000).toFixed(2);
      flushLogs(`[GroupSync] Finished in ${duration}s`);
   }
};
